import React, { useEffect } from "react";

// lightweight per-page SEO: title, description, canonical, and optional JSON-LD
export default function useSEO({ title, description, jsonLd, lang } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (lang) document.documentElement.lang = lang;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    let ld;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.text = JSON.stringify(jsonLd);
      ld.id = "page-jsonld";
      const old = document.getElementById("page-jsonld");
      if (old) old.remove();
      document.head.appendChild(ld);
    }
    return () => { if (ld) ld.remove(); };
  }, [title, description, jsonLd, lang]);
}
